import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { baseUrl } from 'src/core/constants';
import { fetch as fetchRequest, saveContractIds } from 'src/utils/refetch';
import { headers } from '../constants';
import { UserQueryModel } from './types';
import {
  setFirstName,
  setSmartCardNumber,
  getFirstName,
  setLastName, setCustomerId,
} from '../../utils/localstorage/LocalStorageHelper';

interface IUserModel {
  user: UserQueryModel['data'];
  isUserLoading: boolean;
  isError: boolean;
  isSuccess: boolean;
  refetchUserQuery: () => void;
  isRefetching: boolean;
  isFetching: boolean;
}

const useUserQuery = (hasToken = false, disabled = false): IUserModel => {
  const token = localStorage.getItem('blue_token');
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const [isError, setIsError] = useState<boolean>(false);
  const {
    data,
    isLoading: isUserLoading,
    refetch: refetchUserQuery,
    isSuccess,
    isRefetching,
    isFetching,
  } = useQuery({
    queryKey: [`me`],
    queryFn: () =>
      fetchRequest(`${baseUrl}/user/me`, {
        headers: {
          ...headers,
          'Sky-Token': localStorage.getItem('sky_token'),
          'Sky-Refresh-Token': localStorage.getItem('sky_refresh_token'),
        },
      }).then((res: any) => {
        if (!res.response.ok) {
          setIsError(true);
          throw new Error('Network response was not ok');
        }
        if (res.response.ok) {
          if (res?.body && res.body?.data) {
            if (res.body?.data?.contract_ids) {
              saveContractIds(res.body.data.contract_ids);
            }
            if(res.body?.data?.vorname) {
              setFirstName(res.body.data.vorname);
            }
            if(res.body?.data?.name) {
             setLastName(res.body.data.name);
            }
            if(res.body?.data?.smartcardNr) {
              setSmartCardNumber(res.body.data.smartcardNr);
            }
            if(res?.body?.data?.customerNr) {
             setCustomerId(res.body.data.customerNr);
            }
          }
          return res.body.data;
        }
      }),
    enabled: (!!token || hasToken) || !disabled,
  });

  const user = data;

  return { user, isUserLoading, isError, isSuccess, refetchUserQuery, isRefetching, isFetching };
};

export default useUserQuery;
